module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-4.5a811461.jpg";